import React from 'react';
import classnames from 'classnames';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { H5 } from '@styled';
import colors from '@general/colors';
import { mediaQueries } from '@general/breakpoints';

const TabStyled = styled(H5)`
    cursor: pointer;
    font-size: 0.75rem;
    line-height: 1.4;

    &.active {
        border-bottom: 6px solid ${colors.primary};
        padding-bottom: 11px;
        cursor: text;
    }

    &:not(:last-child) {
        margin-right: 24px;
    }

    @media ${mediaQueries.lg} {
        font-size: 18px;
    }
`;

const Tab = props => {
    const { title, activeTabKey, tabKey, onClick } = props;

    const handleOnClick = () => {
        if (!onClick) return;
        onClick(tabKey);
    };

    return (
        <TabStyled
            onClick={handleOnClick}
            className={classnames({
                active: activeTabKey === tabKey,
                'cursor-pointer': activeTabKey !== tabKey,
            })}
        >
            {title}
        </TabStyled>
    );
};

Tab.propTypes = {
    title: PropTypes.string,
    activeTabKey: PropTypes.string,
    tabKey: PropTypes.string,
    onClick: PropTypes.func,
};

export default Tab;
